import moment from "moment";

// Filtros compartidos entre los tabs de reportes (Resultados, Ventas, Gastos).
// Cualquier filtro que tenga que aplicarse de forma transversal entre los tabs
// vive acá. Hoy: el mes de referencia del calendario y el rango de período.

// Rangos que forzan una fecha-fin canónica distinta del endMonth actual.
// Cuando el caller selecciona uno de estos rangos, también sincronizamos
// endMonth para que el calendario y la consulta queden coherentes entre sí.
// Para agregar un nuevo rango con override (previousMonth, previousQuarter…)
// basta con sumar la entrada — la action no cambia.
//
// `previousYear` solía vivir aquí — lo movimos a `resolveDateRange` para que
// el rango sea self-contained y no se rompa cuando el usuario cambia
// endMonth desde el calendario después de haber elegido "Año Anterior".
const RANGE_OVERRIDES = {};

const state = () => ({
    endMonth: moment().toDate(),
    selectedPeriodRange: "lastYear",
});

const mutations = {
    SET_END_MONTH(state, date) {
        state.endMonth = date;
    },
    SET_SELECTED_PERIOD_RANGE(state, range) {
        state.selectedPeriodRange = range;
    },
};

const actions = {
    setPeriodRange({ commit }, range) {
        commit("SET_SELECTED_PERIOD_RANGE", range);
        const overrideFn = RANGE_OVERRIDES[range];
        if (overrideFn) commit("SET_END_MONTH", overrideFn());
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
